import React, { useEffect, useState } from "react";

import SelectARecordToView from "components/Records/SelectARecordToView";
import PeopleMovementTab from "components/Flow/Tabs/PeopleMovementTab";
import AddressesMovementTab from "components/Flow/Tabs/AddressesMovementTab";
import BasePaper from "components/Base/BasePaper";
import GenericTabs, {
  GenericTabItem,
} from "components/Base/GenericTabs";

import {
  getNodePeople,
  getNodeAddresses,
  moveItemsBetweenNodes,
  campaignNodeAPI,
} from "api/Campaigns/CampaignAPI";

interface CampaignBottomDrawerProps {
  selectedNode: any | null;
  onUpdateNode: (updatedNode: any) => void;
  savingNode: boolean;
}

const CampaignBottomDrawer: React.FC<
  CampaignBottomDrawerProps
> = ({
  selectedNode,
  onUpdateNode,
  savingNode,
}) => {
  const [tabIndex, setTabIndex] = useState(0);
  const [nodeData, setNodeData] = useState<any | null>(
    null
  );

  useEffect(() => {
    setNodeData(
      selectedNode ? { ...selectedNode } : null
    );

    // Reset the active tab when switching nodes.
    setTabIndex(0);
  }, [selectedNode]);

  if (!selectedNode || !nodeData) {
    return (
      <SelectARecordToView
        itemName="node"
        message="Select a node to view details"
        maxHeight={150}
      />
    );
  }

  const rawItemTypes = nodeData.data?.itemTypes;

  let normalizedItemTypes: string[] = [];

  if (Array.isArray(rawItemTypes)) {
    normalizedItemTypes = rawItemTypes;
  } else if (rawItemTypes === "Both") {
    normalizedItemTypes = [
      "People",
      "Addresses",
    ];
  } else if (typeof rawItemTypes === "string") {
    normalizedItemTypes = [rawItemTypes];
  }

  const showPeople =
    normalizedItemTypes.includes("People");

  const showAddresses =
    normalizedItemTypes.includes("Addresses");

  const showTabs = showPeople && showAddresses;

  const peopleContent = (
    <PeopleMovementTab
      nodeData={nodeData}
      nodeAPI={campaignNodeAPI}
      getNodePeople={getNodePeople}
      movePeopleBetweenNodes={
        moveItemsBetweenNodes
      }
    />
  );

  const addressesContent = (
    <AddressesMovementTab
      nodeData={nodeData}
      nodeAPI={campaignNodeAPI}
      getNodeAddresses={getNodeAddresses}
      moveAddressesBetweenNodes={
        moveItemsBetweenNodes
      }
    />
  );

  const tabs: GenericTabItem[] = [
    {
      id: "people",
      label: "People",
      content: peopleContent,
    },
    {
      id: "addresses",
      label: "Addresses",
      content: addressesContent,
    },
  ];

  return (
    <BasePaper>
      {showTabs ? (
        <GenericTabs
          tabs={tabs}
          value={tabIndex}
          onChange={setTabIndex}
          contentPadding={0}
          keepMounted
          tabsSx = {{
            mt: 2,
          }}
          sx={{
            width: "100%",
          }}
        />
      ) : (
        <>
          {showPeople && peopleContent}
          {showAddresses && addressesContent}
        </>
      )}
    </BasePaper>
  );
};

export default CampaignBottomDrawer;

